// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.FormListSection_actionButtons__112ds {\n  display: flex;\n  justify-content: flex-end;\n  flex: 1 1;\n  width: 100%; }\n  .FormListSection_actionButtons__112ds.FormListSection_empty__9Kn3V {\n    justify-content: center; }\n    .FormListSection_actionButtons__112ds.FormListSection_empty__9Kn3V.FormListSection_hideNotFound__21Xtt {\n      justify-content: flex-end; }\n\n.FormListSection_fieldBlock__PUlgT {\n  margin-bottom: 24px; }\n\n.FormListSection_wrapper__1hx-8.FormListSection_viewEmpty__2QWmN {\n  padding-bottom: 60px; }\n\n.FormListSection_notFound__2reXl {\n  margin-bottom: 24px;\n  margin-top: 28px; }\n", ""]);
// Exports
exports.locals = {
	"actionButtons": "FormListSection_actionButtons__112ds",
	"empty": "FormListSection_empty__9Kn3V",
	"hideNotFound": "FormListSection_hideNotFound__21Xtt",
	"fieldBlock": "FormListSection_fieldBlock__PUlgT",
	"wrapper": "FormListSection_wrapper__1hx-8",
	"viewEmpty": "FormListSection_viewEmpty__2QWmN",
	"notFound": "FormListSection_notFound__2reXl"
};
module.exports = exports;
